var map = {
	"./error.json": "22b7",
	"./event.json": "8d7b",
	"./fire.json": "14eb",
	"./paper.json": "a1e2",
	"./ton.json": "f61a",
	"./wait.json": "16ee",
	"./wallet.json": "d967",
	"./win.json": "1cc4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bd76";